// @ts-strict-ignore
/**
 * Created by claudenbach on 2/7/2017.
 */

import { LMEditorService } from './lm-editor.service';

export const isCheckControlEditable = (
  lmEditorService: LMEditorService,
  row: number,
  cell: number,
  value: any,
  columnDef: ListGridColumn,
  dataView: LMListDataView,
  dataGrid: SohoDataGridStatic
): boolean  => {

  if (!dataView || dataView.isTreeMoreLink) {
    return;
  }

  if (!columnDef.displayField?.fieldId) {
    return;
  }

  if (columnDef.displayField.validity) {
    if (!lmEditorService.isConditionValid(columnDef.displayField.validity, dataView)) {
      return false;
    }
  }

  const isChecked = dataView?.fields[columnDef.displayField.fieldId].value as string;
  const checkControlActions: Array<LMCheckControlAction> = isChecked ? columnDef.displayField.uncheckActions : columnDef.displayField.checkActions;

  if (checkControlActions === null || checkControlActions.length === 0) {
    return false;
  }

  for (const checkControlAction of checkControlActions) {
    if (checkControlAction.condition !== undefined) {
      const conditions: LMCondition[] = [];
      conditions[0] = checkControlAction.condition;

      if (lmEditorService.isConditionValid(conditions, dataView)) {
        return true; // is editable
      }
    } else {
      return true; // is editable
    }
  }

  return false; // is readonly
};
